import { ValueFormatterParams } from 'ag-grid-community';
import { format } from 'date-fns';

import { DATETIME_FORMAT } from '@/constants';
import { parseWallClock } from '@/utils/wallClock';

export function dateTimeFormatter(
  params: { value: string } | ValueFormatterParams<any, string>,
): string {
  const dateValue = params.value;
  if (!dateValue) {
    return '';
  }

  // API timestamps are wall-clock time; see src/utils/wallClock.ts
  const date = parseWallClock(dateValue);
  if (!date) {
    return '';
  }

  return format(date, DATETIME_FORMAT);
}
